import * as React from "react";
import { icons as lucide } from "lucide-react";

import Cover from "../images/cover.png";

export function Footer() {
  return (
    <div className="-mx-4 lg:mx-0 w-[calc(100%+32px)] lg:w-full flex justify-center">
      <div className="z-[0] h-full w-full max-w-[1200px] flex flex-col items-center">
        <div className="w-full aspect-[1.000] sm:aspect-[1.414] md:aspect-[1.732] lg:aspect-[2.236] xl:aspect-[2.646] bg-zinc-900/30 border-t border-zinc-900 relative overflow-hidden">
          <div
            className="absolute bg-[size:min(75%,48rem)] opacity-[0.035] top-0 left-0 w-full h-full"
            style={{
              backgroundImage: `url(${Cover})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "right bottom",
            }}
          />
          <div className="text-white absolute top-[10%] md:top-[15%] left-[10%] flex flex-col space-y-12 md:space-y-16">
            <div className="flex items-start space-x-12">
              <div className="grow shrink w-[1/3] flex flex-col space-y-2 group/container">
                <div className="opacity-[0.125] space-x-[4px] flex items-center">
                  <lucide.Package size={16} strokeWidth={2.5} className="text-zinc-400 group-hover/container:animate-[jump_0.50s_linear_0.00s]" />
                  <lucide.Plus size={16} strokeWidth={2.5} className="text-zinc-300/50 group-hover/container:animate-[jump_0.50s_linear_0.10s]" />
                  <lucide.Info size={16} strokeWidth={2.5} className="text-zinc-400 group-hover/container:animate-[jump_0.50s_linear_0.20s]" />
                </div>
                <div className="text-[17px] font-[550] opacity-[0.30] select-none">product</div>
                <div className="flex flex-col space-y-[6px]">
                  <a href="/" className="text-[15px] font-medium opacity-[0.20] hover:opacity-[0.30] transition-opacity duration-[150ms] ease-in-out">
                    why
                  </a>
                  <a href="/login" className="text-[15px] font-medium opacity-[0.20] hover:opacity-[0.30] transition-opacity duration-[150ms] ease-in-out">
                    login
                  </a>
                  <a href="/pricing" className="text-[15px] font-medium opacity-[0.20] hover:opacity-[0.30] transition-opacity duration-[150ms] ease-in-out">
                    pricing
                  </a>
                  {/*
                  <a href="/sales" className="text-[15px] font-medium opacity-[0.20] hover:opacity-[0.30] transition-opacity duration-[150ms] ease-in-out">
                    sales
                  </a>
                  */}
                  <a href="/docs" className="text-[15px] font-medium opacity-[0.20] hover:opacity-[0.30] transition-opacity duration-[150ms] ease-in-out">
                    docs
                  </a>
                  <a href="/changelog" className="text-[15px] font-medium opacity-[0.20] hover:opacity-[0.30] transition-opacity duration-[150ms] ease-in-out">
                    changelog
                  </a>
                  <a href="/terms" className="text-[15px] font-medium opacity-[0.20] hover:opacity-[0.30] transition-opacity duration-[150ms] ease-in-out">
                    terms
                  </a>
                </div>
              </div>
              <div className="grow shrink w-[1/3] flex flex-col space-y-2 group/container">
                <div className="opacity-[0.125] space-x-[4px] flex items-center">
                  <lucide.PersonStanding size={16} strokeWidth={2.5} className="text-zinc-400 group-hover/container:animate-[jump_0.50s_linear_0.00s]" />
                  <lucide.Plus size={16} strokeWidth={2.5} className="text-zinc-300/50 group-hover/container:animate-[jump_0.50s_linear_0.10s]" />
                  <lucide.ShieldCheck size={16} strokeWidth={2.5} className="text-zinc-400 group-hover/container:animate-[jump_0.50s_linear_0.20s]" />
                </div>
                <div className="text-[17px] font-[550] opacity-[0.30] select-none">company</div>
                <div className="flex flex-col space-y-[6px]">
                  {/*
                  <a href="/about" className="text-[15px] font-medium opacity-[0.20] hover:opacity-[0.30] transition-opacity duration-[150ms] ease-in-out">
                    about
                  </a>
                  */}
                  <a href="/blog" className="text-[15px] font-medium opacity-[0.20] hover:opacity-[0.30] transition-opacity duration-[150ms] ease-in-out">
                    blog
                  </a>
                  <a href="/customers" className="text-[15px] font-medium opacity-[0.20] hover:opacity-[0.30] transition-opacity duration-[150ms] ease-in-out">
                    customers
                  </a>
                  {/*
                  <a href="/careers" className="text-[15px] font-medium opacity-[0.20] hover:opacity-[0.30] transition-opacity duration-[150ms] ease-in-out">
                    careers
                  </a>
                  <a href="/security" className="text-[15px] font-medium opacity-[0.20] hover:opacity-[0.30] transition-opacity duration-[150ms] ease-in-out">
                    security
                  </a>
                  <a href="/contact" className="text-[15px] font-medium opacity-[0.20] hover:opacity-[0.30] transition-opacity duration-[150ms] ease-in-out">
                    contact
                  </a>
                  */}
                </div>
              </div>
              <div className="grow shrink w-[1/3] flex flex-col space-y-2 group/container">
                <div className="opacity-[0.125] space-x-[4px] flex items-center">
                  <lucide.MessagesSquare size={16} strokeWidth={2.5} className="text-zinc-400 group-hover/container:animate-[jump_0.50s_linear_0.00s]" />
                  <lucide.Plus size={16} strokeWidth={2.5} className="text-zinc-300/50 group-hover/container:animate-[jump_0.50s_linear_0.10s]" />
                  <lucide.CircleHelp size={16} strokeWidth={2.5} className="text-zinc-400 group-hover/container:animate-[jump_0.50s_linear_0.20s]" />
                </div>
                <div className="text-[17px] font-[550] opacity-[0.30] select-none">help</div>
                <div className="flex flex-col space-y-[6px]">
                  {/*
                  <a href="/faq" className="text-[15px] font-medium opacity-[0.20] hover:opacity-[0.30] transition-opacity duration-[150ms] ease-in-out">
                    faq
                  </a>
                  */}
                  {/*
                  <a href="/status" className="text-[15px] font-medium opacity-[0.20] hover:opacity-[0.30] transition-opacity duration-[150ms] ease-in-out">
                    status
                  </a>
                  */}
                  <a
                    href="https://github.com/subtrace/subtrace"
                    className="text-[15px] font-medium opacity-[0.20] hover:opacity-[0.30] transition-opacity duration-[150ms] ease-in-out"
                  >
                    github
                  </a>
                  <a href="/discord" className="text-[15px] font-medium opacity-[0.20] hover:opacity-[0.30] transition-opacity duration-[150ms] ease-in-out">
                    discord
                  </a>
                  {/*
                  <a href="/compare" className="text-[15px] font-medium opacity-[0.20] hover:opacity-[0.30] transition-opacity duration-[150ms] ease-in-out">
                    compare
                  </a>
                  */}
                </div>
              </div>
            </div>
            <div className="flex items-start text-[15px] font-medium opacity-[0.05]">&copy; 2025 Subtrace, Inc.</div>
          </div>
        </div>
      </div>
    </div>
  );
}
